import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

const DEFAULT_CLEAR_KEYS = ["prefill"];

type Options = { clearKeys?: string[] };

export function useCloseMaskDialog(options?: Options) {
  const navigate = useNavigate();
  const clearKeys = options?.clearKeys ?? DEFAULT_CLEAR_KEYS;
  const clearKeysSig = clearKeys.join("|");

  return useCallback(() => {
    return navigate({
      to: ".",
      search: (prev: Record<string, unknown> | undefined) => {
        const next = { ...(prev ?? {}) };
        delete next.action;
        for (const k of clearKeysSig.split("|").filter(Boolean)) {
          delete next[k];
        }
        return next;
      },
      replace: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, clearKeysSig]);
}
